import "@/App.css";
import "@/styles/nossa-responsive.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SiteFrame } from "@/components/nossa/SiteFrame";
import { useGoogleAnalyticsPageViews } from "@/hooks/useGoogleAnalyticsPageViews";
import { useNossaData } from "@/hooks/useNossaData";
import ContactPage from "@/pages/ContactPage";
import Home from "@/pages/Home";
import { CookiePolicyPage, LegalNoticePage, PrivacyPolicyPage } from "@/pages/LegalPages";
import MenuPage from "@/pages/MenuPage";
import PromotionsPage from "@/pages/PromotionsPage";

const AppRoutes = () => {
  useGoogleAnalyticsPageViews();
  const { brand, menu, menuNote, contact, reviews, promotions } = useNossaData();

  return (
    <SiteFrame contact={contact}>
      <Routes>
        <Route path="/" element={<Home brand={brand} menu={menu} reviews={reviews} />} />
        <Route path="/menu" element={<MenuPage menu={menu} menuNote={menuNote} />} />
        <Route path="/promociones" element={<PromotionsPage promotions={promotions} />} />
        <Route path="/contacto" element={<ContactPage contact={contact} />} />
        <Route path="/aviso-legal" element={<LegalNoticePage />} />
        <Route path="/politica-privacidad" element={<PrivacyPolicyPage />} />
        <Route path="/politica-cookies" element={<CookiePolicyPage />} />
      </Routes>
    </SiteFrame>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
